// drinkUtils.js

const API_URL = process.env.REACT_APP_API_URL

export async function fetchFilteredDrinks(filters = {}) {
  const params = new URLSearchParams({
    filter_mode: filters.filterMode || 'OR',
    categories: (filters.selectedCategories || []).join(','),
    ingredients: (filters.selectedIngredients || []).join(','),
    tags: (filters.selectedTags || []).join(','),
    media: (filters.selectedMedia || []).join(','),
    descriptors: (filters.selectedDescriptors || []).join(','),
    preparation_methods: (filters.selectedPreparationMethods || []).join(','),
    cursed: filters.isCursed ? 'true' : 'false',
    search: filters.searchTerm || '',
    show_favorites: filters.showFavorites ? 'true' : 'false',
    sort_field: filters.sortField || 'name',
    sort_order: filters.sortOrder || 'asc',
  }).toString();

  const response = await fetch(`${API_URL}/api/filter-drinks/?${params}`, {
    method: 'GET',
    credentials: 'include',
  });
  const data = await response.json();
  return data.drinks || [];
}

export async function fetchDrinkNotes(drinkIds = []) {
  const csrfToken = getCSRFToken();
  const response = await fetch(`${API_URL}/api/carousel-drink-details/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': csrfToken,
    },
    credentials: 'include',
    body: JSON.stringify({ ids: drinkIds }),
  });

  const data = await response.json();
  const notesMap = new Map(data.drinks.map((d) => [d.id, d.notes || '']));
  return notesMap;
}

function getCSRFToken() {
  const match = document.cookie.match(/csrftoken=([^;]+)/);
  return match ? match[1] : null;
}
